module.exports = __webpack_public_path__ + "media/eastern-wood-pewee-2.6c72bf70.mp3";